import React, { Component } from 'react';
import { Grid, } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import useStyles from './mobileStyles';
import { createRefetchContainer, graphql, QueryRenderer } from 'react-relay';
import { Bar } from 'react-chartjs-2';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import environment from '../../environment';
import WMMobileLeaderboard from './WMMobileLeaderboard';

const wmMobileLeadContainerQuery = graphql`
    query WMMobileLeadContainerQuery(
        $event_token: String!
        $guest_token: String!
        $quarter_id: Int!
        $page_number: Int
        $search_val: String
    ){
        ...WMMobileLeaderboard_getLonewolfPersonalLeaderboardData @arguments(event_token: $event_token, guest_token: $guest_token, quarter_id: $quarter_id, page_number: $page_number, search_val: $search_val)
    }
`;

class WMMobileLeadContainer extends Component {
    constructor(props){
        super(props);
        this.state = {
            leaderboard: [],
            total_page: 1,
            search_val: '',
        }
    }

    updateSearch(str){
        this.setState({ search_val: str });
    }

    render(){
        const { classes, page_number, user, event_token, quarter_id, changePage, landscape } = this.props;
        const { leaderboard, total_page, search_val } = this.state;
        const variables = { event_token: event_token, guest_token: ' ', quarter_id: quarter_id, page_number: page_number, search_val: search_val };

        return (
            <div className={classes.wmTableContainer} key='wm-left-table'>
                <p className={classes.wmTableTitle}>LEADERBOARD</p>
                <QueryRenderer
                    environment={environment}
                    query={wmMobileLeadContainerQuery}
                    variables={variables}
                    render={({ error, props }) => {
                        if(props){
                            return (
                                <WMMobileLeaderboard
                                    getLonewolfPersonalLeaderboardData={props}
                                    changePage={changePage}
                                    page_number={page_number}
                                    user={user}
                                    landscape={landscape}
                                />
                            )
                        }
                    }}
                />
                <div style={{marginTop: '1em'}} key='wm-mobile-pagination'>
                    <div style={{float: 'left'}}>
                        <input
                            type='text' className={classes.searchBar}
                            value={search_val} placeholder='Search'
                            onChange={(e) => this.updateSearch(e.target.value)}
                        />
                    </div>
                </div>
            </div>
        )
    }
}

export default withStyles(useStyles)(WMMobileLeadContainer);